/* tslint:disable */
/* eslint-disable */
/**
 * Bank API Schema
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @interface PostAdditionMerchantGeneralBlockListRequest
 */
export interface PostAdditionMerchantGeneralBlockListRequest {
    /**
     * 
     * @type {string}
     * @memberof PostAdditionMerchantGeneralBlockListRequest
     */
    'merchantName': string;
    /**
     * 
     * @type {string}
     * @memberof PostAdditionMerchantGeneralBlockListRequest
     */
    'merchantId': string;
    /**
     * 
     * @type {string}
     * @memberof PostAdditionMerchantGeneralBlockListRequest
     */
    'acquirerId': string;
    /**
     * 
     * @type {string}
     * @memberof PostAdditionMerchantGeneralBlockListRequest
     */
    'patternType': PostAdditionMerchantGeneralBlockListRequestPatternTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof PostAdditionMerchantGeneralBlockListRequest
     */
    'storeType': PostAdditionMerchantGeneralBlockListRequestStoreTypeEnum;
    /**
     * 
     * @type {Array<string>}
     * @memberof PostAdditionMerchantGeneralBlockListRequest
     */
    'allowedOrganizationIds': Array<string>;
}

export const PostAdditionMerchantGeneralBlockListRequestPatternTypeEnum = {
    exact: 'EXACT',
    prefix: 'PREFIX',
    suffix: 'SUFFIX',
    regexp: 'REGEXP',
    unknown: 'UNKNOWN'
} as const;

export type PostAdditionMerchantGeneralBlockListRequestPatternTypeEnum = typeof PostAdditionMerchantGeneralBlockListRequestPatternTypeEnum[keyof typeof PostAdditionMerchantGeneralBlockListRequestPatternTypeEnum];
export const PostAdditionMerchantGeneralBlockListRequestStoreTypeEnum = {
    all: 'ALL',
    physicalStore: 'PHYSICAL_STORE',
    ecStore: 'EC_STORE',
    unknown: 'UNKNOWN'
} as const;

export type PostAdditionMerchantGeneralBlockListRequestStoreTypeEnum = typeof PostAdditionMerchantGeneralBlockListRequestStoreTypeEnum[keyof typeof PostAdditionMerchantGeneralBlockListRequestStoreTypeEnum];


